export * from '../../../components/FooterV2/FooterColumns/FooterColumns';
